export default __webpack_public_path__ + "static/media/KZ.T.13.2509.a66c3ef4.svg";